export default __webpack_public_path__ + "static/media/upload.6c04de64.svg";